// Quote requests (contact-form submissions).
export const leadsEn = {
  'leads.subtitle': 'Submissions from the website contact form.',
  'leads.status.new': 'New',
  'leads.status.contacted': 'Contacted',
  'leads.status.qualified': 'Qualified',
  'leads.status.won': 'Won',
  'leads.status.lost': 'Lost',
  'leads.status.spam': 'Spam',
  'leads.empty.title': 'No quote requests',
  'leads.empty.body': 'New submissions from the contact form appear here.',
  'leads.col.contact': 'Contact',
  'leads.col.interest': 'Interest',
  'leads.col.status': 'Status',
  'leads.col.received': 'Received',
  'leads.col.actions': 'Actions',
  'leads.open': 'Open',
  'leads.prev': '← Previous',
  'leads.next': 'Next →',
  'leads.pageOf': 'Page {page} of {total}',

  'leads.detail.updated': 'Quote request updated',
  'leads.detail.email': 'Email',
  'leads.detail.company': 'Company',
  'leads.detail.role': 'Job title',
  'leads.detail.country': 'Country',
  'leads.detail.product': 'Product',
  'leads.detail.quantity': 'Quantity',
  'leads.detail.timeline': 'Timeline',
  'leads.detail.language': 'Language',
  'leads.detail.sentFrom': 'Sent from',
  'leads.detail.received': 'Received',
  'leads.detail.reply': 'Reply by email',
  // Subject line of the reply email. Written in the visitor's language, not the admin's.
  'leads.detail.replySubject': 'Your packaging quote request',
  'leads.detail.status': 'Status',
  'leads.detail.notes': 'Internal notes',
  'leads.detail.notesHint': 'Only visible in the CMS.',
} as const

export const leadsId: Record<keyof typeof leadsEn, string> = {
  'leads.subtitle': 'Kiriman dari formulir kontak situs web.',
  'leads.status.new': 'Baru',
  'leads.status.contacted': 'Dihubungi',
  'leads.status.qualified': 'Terkualifikasi',
  'leads.status.won': 'Berhasil',
  'leads.status.lost': 'Gagal',
  'leads.status.spam': 'Spam',
  'leads.empty.title': 'Belum ada permintaan penawaran',
  'leads.empty.body': 'Kiriman baru dari formulir kontak akan muncul di sini.',
  'leads.col.contact': 'Kontak',
  'leads.col.interest': 'Minat',
  'leads.col.status': 'Status',
  'leads.col.received': 'Diterima',
  'leads.col.actions': 'Aksi',
  'leads.open': 'Buka',
  'leads.prev': '← Sebelumnya',
  'leads.next': 'Berikutnya →',
  'leads.pageOf': 'Halaman {page} dari {total}',

  'leads.detail.updated': 'Permintaan penawaran diperbarui',
  'leads.detail.email': 'Email',
  'leads.detail.company': 'Perusahaan',
  'leads.detail.role': 'Jabatan',
  'leads.detail.country': 'Negara',
  'leads.detail.product': 'Produk',
  'leads.detail.quantity': 'Jumlah',
  'leads.detail.timeline': 'Target waktu',
  'leads.detail.language': 'Bahasa',
  'leads.detail.sentFrom': 'Dikirim dari',
  'leads.detail.received': 'Diterima',
  'leads.detail.reply': 'Balas lewat email',
  'leads.detail.replySubject': 'Permintaan penawaran kemasan Anda',
  'leads.detail.status': 'Status',
  'leads.detail.notes': 'Catatan internal',
  'leads.detail.notesHint': 'Hanya terlihat di CMS.',
}
